import PlusIcon from './PlusIcon';

export default PlusIcon;
